interface State {
    toolTipData: any | null;
}

const initialState: State = {
    toolTipData: null
};

const state: State = {
    ...initialState
};


const getters = {
    toolTipData: (state: State) => state.toolTipData
};

const mutations = {
    setToolTipData(state: State, data: any) {
        state.toolTipData = data;
    }
};

const actions = {
    setToolTipData({ commit }: any, data: any) {
        commit('setToolTipData', data);
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};

